export default {
  title: 'Raport MRR',
  fields: {
    name: 'Nazwa',
    area: 'Obszar',
    mrr: 'MRR (netto)',
  },
  buttons: {
    download_report: 'Pobierz raport',
  },
  toasts: {
    failed_to_load_data: 'Nie udało się załadować danych, odśwież stronę',
  },
};
